import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Button, Table, Space, message } from "antd";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import LiensModel from "./LiensModel";
import moment from "moment";
import { useQuery } from "../../../../../helpers/utility";
import {
  createLiens,
  deleteLiens,
  getLiens,
  updateLiens,
} from "../../../../../services/adminForm.services";

const dateFormat = "YYYY-MM-DD";

const OwnerLiens = ({ selectedOwner }) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const refreshPage = () => {
    setRefresh((prevValue) => !prevValue);
  };

  const query = useQuery();
  const applicationId = query.get("id");

  const columns = [
    {
      title: "Creditor",
      dataIndex: "creditor",
      key: "creditor",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      ellipsis: true,
      width: 100,
    },
    {
      title: "County",
      dataIndex: "county",
      key: "county",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Property",
      dataIndex: "property",
      key: "property",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing No",
      dataIndex: "filing_no",
      key: "filing_no",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing Date",
      dataIndex: "filing_date",
      key: "filing_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Release Date",
      dataIndex: "release_date",
      key: "release_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Action",
      key: "action",
      width: 160,
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  useEffect(() => {
    fetchLiens();
  }, [selectedOwner, refresh]);

  function fetchLiens() {
    getLiens({
      id: applicationId,
      detailsType: "owner-liens",
      ownership: selectedOwner,
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.error("get Owner liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Something Went wrong"
          );
        } else {
          message.error("get Owner liens error");
        }
      });
  }

  function saveLiens(values) {
    let data = values;
    data.filing_date = moment(values.filing_date).format(dateFormat);
    data.release_date = moment(values.release_date).format(dateFormat);
    data.details_type = "owner-liens";
    data.application = applicationId;
    data.ownership = selectedOwner;

    createLiens(data)
      .then((res) => {
        setVisible(false);
        message.success(res.data.message || "Saved Liens");
        refreshPage();
      })
      .catch((error) => {
        console.error("save Owner liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Failed to save liens"
          );
        } else {
          message.error("save Owner lines error");
        }
      });
  }

  function handleUpdateLiens(values) {
    let data = values;
    data.filing_date = moment(values.filing_date).format(dateFormat);
    data.release_date = moment(values.release_date).format(dateFormat);
    data.application = applicationId;
    data.details_type = "owner-liens";

    updateLiens(editTable.id, data)
      .then((res) => {
        setVisible(false);
        message.success(res.data.message || "Updated Liens");
        refreshPage();
      })
      .catch((error) => {
        console.error("update Owner liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Failed to update liens"
          );
        } else {
          message.error("update Owner liens error");
        }
      });
  }

  function removeColumn(id) {
    deleteLiens(id)
      .then((res) => {
        message.success(res.data.message || "Deleted Liens");
        fetchLiens(applicationId, "owner-liens");
      })
      .catch((error) => {
        console.error("delete Owner liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Failed to delete Leins"
          );
        } else {
          message.error("delete Owner liens error");
        }
      });
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <Button
            onClick={() => openModal({ status: "create" })}
            type="secondary"
            style={{
              marginBottom: 16,
            }}
          >
            Add Owner Details
          </Button>
        </Col>
        <Col span={24}>
          <Table
            size="small"
            columns={columns}
            pagination={false}
            dataSource={data}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
      {visible && (
        <LiensModel
          create={saveLiens}
          update={handleUpdateLiens}
          setVisible={setVisible}
          title="Owner Liens"
          editTable={editTable}
        />
      )}
    </Fragment>
  );
};

export default OwnerLiens;
